import { Button, Card, Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import {
  deleteDocument,
  downloadDocument,
  getAllDocument,
} from './DocumentSlice';
import { useDispatch, useSelector } from 'react-redux';

import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import ModalUploadFile from '../../components/Modal/ModalUploadFile';
import { Table } from 'ant-table-extensions';
import { useTranslation } from 'react-i18next';

function Document(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const allDocument = useSelector((state) => state.document.documents);

  const [isModalUploadDocument, setIsModalUploadDocument] = useState(false);
  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
  });

  useEffect(() => {
    dispatch(getAllDocument({ token }));
    setPagination({ ...pagination, total: allDocument?.length });
  }, []);

  const columns = [
    {
      dataIndex: 'key',
      sort: 'disabled',
      width: 100,
      key: 'key',
      render: (id) => <i className="feather icon-book text-c-blue" />,
    },
    {
      title: t('document').toUpperCase(),
      dataIndex: 'document',
      key: 'document',
    },
    {
      title: t('edit').toUpperCase(),
      dataIndex: 'edit',
      key: 'edit',
    },
  ];

  const handleDownloadDocument = async (fileId, fileName) => {
    await dispatch(downloadDocument({ fileId, fileName }));
  };

  const handleDeleteDocument = async (fileId) => {
    await dispatch(deleteDocument({ token, fileId }));
    await dispatch(getAllDocument({ token }));
  };

  const data = allDocument?.data?.map((item, idx) => ({
    key: <i className="feather icon-book text-c-blue" />,
    document: item.title,
    edit: (
      <div className="round-actions">
        <a
          href="#!"
          data-toggle="tooltip"
          data-placement="top"
          title={t('download-document')}
          onClick={() => handleDownloadDocument(item.id, item.title)}
        >
          <i className="fa fa-download"></i>
        </a>
        <a
          href="#!"
          data-method="DELETE"
          data-toggle="tooltip"
          data-placement="top"
          onClick={() => handleDeleteDocument(item.id)}
          title={t('delete-document')}
        >
          <i class="fa fa-trash"></i>
        </a>
      </div>
    ),
  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      const pageSize = pagination.pageSize;
      const page = pagination.current - 1;
      dispatch(getAllDocument({ token }));
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };

  return (
    <div className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs floor={[{ name: t('document') }]} />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col sm={12}>
                    <Card id="card">
                      <Card.Header>
                        <h5>Tài Liệu</h5>
                        <span className="d-block m-t-5">
                          {t('list')} <code>{t('document')}</code> VTS
                        </span>
                      </Card.Header>
                      <Card.Body id="cardBody">
                        <Button
                          variant="primary"
                          onClick={() => setIsModalUploadDocument(true)}
                        >
                          + {t('add-new')}
                        </Button>
                        <Table
                          columns={columns}
                          dataSource={data}
                          pagination={pagination}
                          onChange={handleTableChange}
                          scroll={{ x: true }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <ModalUploadFile
                  show={isModalUploadDocument}
                  setShow={setIsModalUploadDocument}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Document;
